import { Component, ViewChild } from '@angular/core';
import { NavController, Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { LeaguesPage } from '../pages/leagues/leagues';

import { AuthService } from './shared/auth.service';
import { LeagueService } from './shared/league.service';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild('mycontent') nav: NavController;

  rootPage: any = LeaguesPage;

  constructor(public platform: Platform, public statusBar: StatusBar, public splashScreen: SplashScreen, public auth: AuthService, public leagueService: LeagueService) {
    this.initializeApp();

    auth.loadUser();
    
  }

  initializeApp() {
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
  }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    this.nav.push(page);
  }

  action(mode, code) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    this.nav.setRoot('ActivatePage', {mode:"resetPassword", oobCode:"qmJ9P7e5OX8reRnFqdELM3l2dIkXicq7dBhEHhNXdtwAAAFdz92fyQ"});
  }
  
  signOut() {
    this.auth.signOut().then(res => {
      console.log(res);
      this.nav.setRoot(this.rootPage);
    })
  }

}




// WEBPACK FOOTER //
// ./src/app/app.component.ts